// libs
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// locale
import { LocaleString } from '@biw/intl';
import { client } from '@biw/contests-core';
// shared components
import { CheckmarkCircleIcon, CloseCircleIcon } from 'components/library';
// scss
import './password-helper.scss';

class PasswordHelper extends React.Component {

    static propTypes = {
        passwordRules: PropTypes.object.isRequired,
        value: PropTypes.string,
        validationResult: PropTypes.func
    }

    state = {
        passwordRulesChecks: {
            hasLowerCase: null,
            hasUpperCase: null,
            hasSpecialChar: null,
            hasNumber: null,
            hasValidLength: null
        }
    };

    lengthTest = ( passwordValue, minLength, maxLength ) => {
        if ( passwordValue.length <= maxLength && passwordValue.length >= minLength ) {
            return true;
        }
    }

    componentDidUpdate( nextProps ) {
        const passwordValue = nextProps.value;
        const {
             isLowerCaseRequired,
             isUpperCaseRequired,
             isSpecialCharRequired,
             isNumberRequired,
             minLength,
             maxLength,
        } = nextProps.passwordRules;

        const passwordRulesChecks = {
            hasLowerCase: isLowerCaseRequired ? /^(?=.*[a-z]).+$/.test( passwordValue ) : true,
            hasUpperCase: isUpperCaseRequired ? /^(?=.*[A-Z]).+$/.test( passwordValue ) : true,
            hasSpecialChar: isSpecialCharRequired ? /[-!$%#@^&*()_+|~=`{}[\]:";'<>?,./]/.test ( passwordValue ) : true, //` <-- editor not smart enough to realize backtick in regex not start of string. need this comment to "close" the string.
            hasNumber: isNumberRequired ? /[0-9]/.test( passwordValue ) : false,
            hasValidLength: ( minLength && maxLength ) ? this.lengthTest( passwordValue, minLength, maxLength ) : false
        };

        if ( passwordValue !== this.props.value && nextProps.validationResult ) {
            nextProps.validationResult( passwordRulesChecks );
        }

        this.setState( { passwordRulesChecks } );
    }

    render() {

        const { passwordRules } = this.props;

        const { passwordRulesChecks } = this.state;

        return (
            <div className="password-rules-container ">
                <div className={ passwordRules.isLowerCaseRequired ? 'rule' : 'hide' }>
                    <div className={ passwordRulesChecks.hasLowerCase === null ? 'rule-icon checkmark-icon' : 'hide' }>
                        <CheckmarkCircleIcon/>
                    </div>
                    <div className={ passwordRulesChecks.hasLowerCase ? 'rule-icon checkmark-icon success' : 'hide' }>
                        <CheckmarkCircleIcon/>
                    </div>
                    <div className={ !passwordRulesChecks.hasLowerCase && passwordRulesChecks.hasLowerCase !== null ? 'rule-icon close-circle-icon' : 'hide' }>
                        <span><CloseCircleIcon/></span>
                    </div>
                    <span><LocaleString code="passwordHelper.rules.lowercaseRequiredLabel" /></span>
                </div>

                <div className={ passwordRules.isUpperCaseRequired ? 'rule' : 'hide' }>
                    <div className={ passwordRulesChecks.hasUpperCase === null ? 'rule-icon checkmark-icon' : 'hide' }>
                        <CheckmarkCircleIcon/>
                    </div>
                    <div className={ passwordRulesChecks.hasUpperCase ? 'rule-icon checkmark-icon success' : 'hide' }>
                        <CheckmarkCircleIcon/>
                    </div>
                    <div className={ !passwordRulesChecks.hasUpperCase && passwordRulesChecks.hasUpperCase !== null ? 'rule-icon close-circle-icon' : 'hide' }>
                        <CloseCircleIcon/>
                    </div>
                    <span><LocaleString code="passwordHelper.rules.uppercaseRequiredLabel" /></span>
                </div>

                <div className={ passwordRules.isSpecialCharRequired ? 'rule' : 'hide' }>
                    <div className={ passwordRulesChecks.hasSpecialChar === null ? 'rule-icon checkmark-icon' : 'hide' }>
                        <CheckmarkCircleIcon/>
                    </div>
                    <div className={ passwordRulesChecks.hasSpecialChar ? 'rule-icon checkmark-icon success' : 'hide' }>
                        <CheckmarkCircleIcon/>
                    </div>
                    <div className={ !passwordRulesChecks.hasSpecialChar && passwordRulesChecks.hasSpecialChar !== null ? 'rule-icon close-circle-icon' : 'hide' }>
                        <CloseCircleIcon/>
                    </div>
                    <span><LocaleString code="passwordHelper.rules.specialCharRequiredLabel" /></span>
                </div>

                <div className={ passwordRules.isNumberRequired  ? 'rule' : 'hide' }>
                    <div className={ passwordRulesChecks.hasNumber === null ? 'rule-icon checkmark-icon' : 'hide' }>
                        <CheckmarkCircleIcon/>
                    </div>
                    <div className={ passwordRulesChecks.hasNumber  ? 'rule-icon checkmark-icon success' : 'hide' }>
                        <CheckmarkCircleIcon/>
                    </div>
                    <div className={ !passwordRulesChecks.hasNumber && passwordRulesChecks.hasNumber !== null ? 'rule-icon close-circle-icon' : 'hide' }>
                        <CloseCircleIcon/>
                    </div>
                    <span><LocaleString code="passwordHelper.rules.numberRequiredLabel" /></span>
                </div>

                <div className={ ( passwordRules.minLength && passwordRules.maxLength )  ? 'rule' : 'hide' }>
                    <div className={ passwordRulesChecks.hasValidLength === null ? 'rule-icon checkmark-icon' : 'hide' }>
                        <CheckmarkCircleIcon/>
                    </div>
                    <div className={ passwordRulesChecks.hasValidLength ? 'rule-icon checkmark-icon success' : 'hide' }>
                        <CheckmarkCircleIcon/>
                    </div>
                    <div className={ !passwordRulesChecks.hasValidLength && passwordRulesChecks.hasValidLength !== null ? 'rule-icon close-circle-icon' : 'hide' }>
                        <CloseCircleIcon/>
                    </div>
                    <span><LocaleString code="passwordHelper.rules.lenghRequirement" replaceOptions={ { ...passwordRules } } /></span>
                </div>

            </div>
        );
    }
}

PasswordHelper = connect(
    // mapStateToProps
    state => ( {
        passwordRules: client.selectors.getClientPasswordRules( state )
    } )
)( PasswordHelper );

export default PasswordHelper;

